module.exports = "/assets/ee276783b79d544f96f4cb6f54ec1769.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AI.png
// module id = 1196
// module chunks = 0